import Axios from "axios";
import {
  SET_SELECTED_SUPPLIER_LIST,
  UNSET_SELECTED_SUPPLIER_LIST
} from "@/store/mutation-types";

import {
  saveUpdateSelectedSupplier,
  getSelectedSupplierList,
  getSelectedSupplierById as getSelectedSupplierByIdApi
} from "@/store/api"; 

// initial state
const state = {
  getSelectedSupplierList: [],
  editingSelectedSupplier: null,
}

const getters = {
  getSelectedSupplierList(state){
    return state.getSelectedSupplierList;
  }
}

const mutations = {
  [SET_SELECTED_SUPPLIER_LIST](state, data) {
    state.getSelectedSupplierList = data;
  },
  [UNSET_SELECTED_SUPPLIER_LIST](state) {
    state.getSelectedSupplierList = [];
  },
  setEditingSelectedSupplier(state, supplier) {
    state.editingSelectedSupplier = supplier;
  },
}

const actions = {
  saveUpdateSelectedSupplier({ commit }, data) {
    console.log(data);
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateSelectedSupplier, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getSelectedSupplierList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getSelectedSupplierList, data)
        .then(function (response) {
          commit('SET_SELECTED_SUPPLIER_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_SELECTED_SUPPLIER_LIST')
          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getSelectedSupplierById({ commit }, id) {
    const getSelectedSupplierById = `${getSelectedSupplierByIdApi}/${id}`;
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.get(getSelectedSupplierById)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },
}

export default {
  state,
  getters,
  actions,
  mutations
};